<template>
  <div>
    <ConfirmationDialog
      ref="confirmDialog"
      cancel-label="no, keep resource"
      confirm-label="Yes, delete"
      confirm-btn-type="danger"
    />

    <ProviderShowHeader
      :tabs="tabs"
      :provider="publisher"
      :create-data="createData"
      @delete="onDeletePublisher"
      @update-field="updateField"
    />
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapState, mapActions } from 'vuex'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import ConfirmationDialog from '@/ui/ConfirmationDialog'
import ProviderShowHeader from '@/reusable/provider-show-header/ProviderShowHeader'

export default {
  components: {
    ConfirmationDialog,
    ProviderShowHeader
  },

  mixins: [registerVuexModule('publisher-show', () => require('./vuex-module'))],

  props: {
    id: [Number, String] // from route
  },

  data() {
    return {
      tabs: [
        { name: 'Products', route: `/publishers/${this.id}/products` },
        {
          name: 'Notes & Tasks',
          route: `/publishers/${this.id}/notes-tasks`
        },
        {
          name: 'Orders & Invoices',
          route: `/publishers/${this.id}/orders-invoices`
        },
        { name: 'Licenses', route: `/publishers/${this.id}/licenses` },
        { name: 'Contacts', route: `/publishers/${this.id}/contacts` },
        { name: 'Addresses', route: `/publishers/${this.id}/addresses` },
        { name: 'Metadata', route: `/publishers/${this.id}/meta-data` }
      ]
    }
  },

  computed: {
    ...mapState('publisher-show', ['publisher', 'createData'])
  },

  created() {
    this.initData(this.id)
  },

  methods: {
    ...mapActions('publisher-show', ['initData', 'updateField']),

    onDeletePublisher() {
      apiTo.GET_PUBLISHER_DELETE_CONFIRMATION(this.id).then(({ data }) => {
        const dialog = this.$refs.confirmDialog.show({
          title: data.messages.default.join('\n') || ' Are you sure you want to delete this publisher?',
          noConfirm: !data.result.deletable,
          noCancel: !data.result.deletable,
          persistent: data.result.deletable
        })

        dialog.onCancel(hide => hide())
        dialog.onConfirm((hide, setLoading) => {
          setLoading()
          apiTo
            .DELETE_PUBLISHER(this.id)
            .then(() => this.$router.replace({ path: '/publishers' }))
            .catch(() => hide())
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
